import React from 'react'

const Home = () => {
  return (
    <div className="container">
        <div className="header">
                <div className="header-title">
                    <h1>Game Genie AI 🧞‍♀️✨</h1>
                </div>
                <div className="header-subtitle">
                  <h2>Empowering game creators with AI-powered tools for concept, story, art and content generation</h2>
                </div>
            </div>
    </div>
  )
}

export default Home